module.exports = __webpack_public_path__ + "static/Banner-25-71b3663570e8f2269783e82773864942.png";